import { strings } from './localization';
export var getValidationErrorMessage = function (form) {
    if (form.field_type === 'textfield' || form.field_type === 'textarea') {
        if (form.requiredMessageEmail) {
            return form.requiredMessageEmail;
        }
        else if (form.requiredMessage) {
            return form.requiredMessage;
        }
        else if (strings["formValidationError_".concat(form.validationType)]) {
            return strings["formValidationError_".concat(form.validationType)];
        }
        else {
            return strings.formDefaultValidationError;
        }
    }
    return '';
};
